import styled from 'styled-components';

export const BackgroundContainer = styled.div<{ background?: string }>`
    position: absolute;
    display: flex;
    align-items: stretch;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: inherit;
    background: ${props => props.background || props.theme.background.messageScreen.defaultPattern.background};
    pointer-events: none;
    box-sizing: border-box;
    background-clip: padding-box;
`;

export const PatternImage = styled.div<{ color?: string; link?: string }>`
    width: 100%;
    background-attachment: fixed;
    background-position: top;
    border-radius: inherit;
    background: ${props => props.color || props.theme.background.messageScreen.defaultPattern.imageColor};
    mask-image: url(${props => props.link || props.theme.background.messageScreen.defaultPattern.imageLink});
`;
